export const schema = {
  '@context': 'http://schema.org/',
  '@type': 'WebPage',
  'name': 'Medical Crowdfunding',
  'speakable': {
    '@type': 'SpeakableSpecification',
    'cssSelector': [
      'headline',
      'Crowdfunding for Healthcare, Surgery & Medical Expenses'
    ]
  },
  'url': 'https://www.ketto.org/cause/medical-fundraising'
};
